import { Trans, useTranslation } from '@sortlist-frontend/translation/ssr';

import { BriefingButton } from '_components/Briefing/versions/NormalBriefing/button';
import { usePublicAppContext } from '_core/context/public-app-context';

import { NoResultsTemplate } from './NoResultsTemplate';

export const NoResultsState = () => {
  const { t } = useTranslation();
  const { getUrl } = usePublicAppContext();
  const claimUrl = getUrl('agency.claim.landing', {});

  return (
    <NoResultsTemplate
      dataTestId="no-results"
      title={t('longtail:noResults.title')}
      subtitle={t('longtail:noResults.subtitle')}
      primaryActions={<BriefingButton label={t('longtail:noResults.cta')} cta="no-results-longtail" />}
      secondaryActions={
        <Trans i18nKey="longtail:noResults.secondaryAction">
          Want to be listed here?&nbsp;
          <span
            className="underline cursor-pointer"
            onClick={() => {
              window.open(claimUrl);
            }}
            role="none">
            Register as a provider
          </span>
        </Trans>
      }
    />
  );
};
